import { ImagePosition, ImageFit, AlignmentEnumAlignment } from "@wix/ambassador-forms-v4-form/types";
import { ImagePosition as ImagePosition$1, ImageFit as ImageFit$1, ImageAlignment } from "../types/image.js";
const toV1ImagePlacement = (imagePosition) => imagePosition === ImagePosition.BELOW ? ImagePosition$1.BOTTOM : ImagePosition$1.TOP;
const toV2ImagePosition = (imagePlacement) => imagePlacement === ImagePosition$1.BOTTOM ? ImagePosition.BELOW : ImagePosition.ABOVE;
const toV1ImageFit = (imageFit) => imageFit === ImageFit.CONTAIN ? ImageFit$1.CONTAIN : ImageFit$1.COVER;
const toV2ImageFit = (imageFit) => imageFit === ImageFit$1.CONTAIN ? ImageFit.CONTAIN : ImageFit.COVER;
const toV1ImageAlignment = (alignment) => {
  if (alignment === AlignmentEnumAlignment.LEFT) {
    return ImageAlignment.LEFT;
  }
  if (alignment === AlignmentEnumAlignment.RIGHT) {
    return ImageAlignment.RIGHT;
  }
  return ImageAlignment.CENTER;
};
const toV2ImageAlignment = (alignment) => {
  if (alignment === ImageAlignment.LEFT) {
    return AlignmentEnumAlignment.LEFT;
  }
  if (alignment === ImageAlignment.RIGHT) {
    return AlignmentEnumAlignment.RIGHT;
  }
  return AlignmentEnumAlignment.CENTER;
};
const toV2LabelMedia = (image) => image ? {
  image: {
    id: image.id,
    width: image.width,
    height: image.height,
    altText: image.altText
  }
} : void 0;
const fromV2LabelMedia = (media) => {
  const image = media?.image;
  if (!image?.id) {
    return void 0;
  }
  return {
    id: image.id,
    width: image.width ?? 0,
    height: image.height ?? 0,
    altText: image.altText ?? void 0
  };
};
function createFieldLabelMediaProperties(view) {
  if (!view.questionImage) {
    return {};
  }
  const mediaSettings = toFieldLabelMediaSettings(view);
  return {
    media: {
      ...view.questionImage,
      ...view.questionImageAltText !== void 0 && {
        altText: view.questionImageAltText
      }
    },
    ...mediaSettings && { mediaSettings }
  };
}
function toFieldLabelMediaSettings(view) {
  const mediaSettings = {
    ...view.questionImagePlacement && {
      imagePosition: view.questionImagePlacement
    },
    ...view.questionImageResize && {
      imageFit: view.questionImageResize
    },
    ...view.questionImageAlignment && {
      imageAlignment: view.questionImageAlignment
    }
  };
  return Object.keys(mediaSettings).length ? mediaSettings : void 0;
}
export {
  createFieldLabelMediaProperties,
  fromV2LabelMedia,
  toV1ImageAlignment,
  toV1ImageFit,
  toV1ImagePlacement,
  toV2ImageAlignment,
  toV2ImageFit,
  toV2ImagePosition,
  toV2LabelMedia
};
//# sourceMappingURL=label-media.js.map
